// components/LenisSmoothScroll.js
import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";

const LenisSmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.0, // Increased from 1.2
      easing: (t) => 1 - Math.cos((t * Math.PI) / 2), // smoother easing (sineOut)
      smooth: true,
      direction: 'vertical',
      gestureDirection: 'vertical',
      smoothTouch: true, // optional: smooth on touch devices
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  return <>{children}</>;
};

export default LenisSmoothScroll;
